import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Tabs, Tab } from 'react-bootstrap'
import {
  userlogoutUserAsync,
  UploadDocumentAsync,
  AuthActions,
  userProfileInfoAsync,
} from '../Auth/_redux'
import {
  MyBalanceTab,
  BasicDetailsTab,
  AccountVerificationTab,
  NotificationSettingTab,
  ChangePasswordTab,
} from '../../modules/profile_settings/pages/tabs'
//import { startProfileKyc, updateProfileKyc, kycStatusCheck } from "../../../modules/profile_settings/_redux/profileApi";
import {
  startProfileKyc,
  updateProfileKyc,
  kycStatusCheck,
} from '../../modules/profile_settings/_redux/profileApi'

const KYC_STATUS_COLOR_CODE = {
  NOT_STARTED: 'info',
  IN_PROGRESS: 'warning',
  COMPLETED: 'success',
}

function KYC() {
  const {
    user,
    isLoading,
    uploadDocumentModal,
    profileDashboard,
  } = useSelector((state) => state.auth)
  const kycData = useSelector((state) => state.profile)
  const [kycStatus, setKycStatus] = useState('')

  const dispatch = useDispatch()

  const navigateToLogout = () => {
    let latestActivity = user.loginActivity[user.loginActivity.length - 1]
    dispatch(userlogoutUserAsync(user._id, latestActivity._id))
  }

  const [isKycLoading, setKycLoader] = useState({
    startKycLoading: false,
    updateKycLoading: false,
  })

  useEffect(() => {
    recheckStatus()
    dispatch(userProfileInfoAsync(user._id))
  }, [])

  useEffect(() => {
    if (kycData && kycData.kycData && kycData.kycData.responseData) {
      setKycLoader({ startKycLoading: false, updateKycLoading: false })
      setKycStatus(kycData.kycData.responseData.kycStatus)
    } else if (user.kycStatus) {
      setKycLoader({ startKycLoading: false, updateKycLoading: false })
      setKycStatus(user.kycStatus)
    }
  }, [kycData, user])

  const startKyc = () => {
    // console.log(profile)
    setKycLoader({ startKycLoading: true, updateKycLoading: false })
    dispatch(startProfileKyc())
  }

  const updateKyc = () => {
    setKycLoader({ startKycLoading: false, updateKycLoading: true })
    dispatch(updateProfileKyc())
  }

  const recheckStatus = () => {
    dispatch(kycStatusCheck())
    if (kycData && kycData.kycData && kycData.kycData.responseData) {
      setKycLoader({ startKycLoading: false, updateKycLoading: false })
      setKycStatus(kycData.kycData.responseData.kycStatus)
    } else if (user.kycStatus) {
      setKycLoader({ startKycLoading: false, updateKycLoading: false })
      setKycStatus(user.kycStatus)
    }
  }

  return (
    <>
      <div className="row">
        <div className="col-md-12 d-flex justify-content-between flex-wrap flex-sm-nowrap">
          <div className="mr-1">
            <h5 className="inpg_ttl mr-5">KYC: Know Your Customer</h5>
            <p className="inpg_p">Regulatory Compliance Process</p>
          </div>
          <div className="d-flex flex-wrap ap_filter_wraper justify-content-end align-items-center">
            <button
              onClick={navigateToLogout}
              disabled={isLoading}
              className="btn btn-def btn_dlalactv"
            >
              LOGOUT
              {isLoading && (
                <span className="ml-3 spinner spinner-white"></span>
              )}
            </button>
          </div>
        </div>
        <div className="col-md-12 mt-5">
          <div className="px-6 pt-0 dash_wt_bx pb-0 ovflhddn mn_tbpnl">
            <div className="m-2 row text-center">
              <div className="col-xl-3 mt-3 mb-2">
                <label>
                  Status:{' '}
                  <b
                    className={`ml-5 mr-2 bg-${KYC_STATUS_COLOR_CODE[kycStatus]} text-light px-4 py-2 rounded`}
                  >
                    {kycStatus}
                  </b>
                  <span onClick={recheckStatus}>
                    <i
                      style={{ cursor: 'pointer' }}
                      className={`fas fa-redo-alt ml-2 text-${KYC_STATUS_COLOR_CODE[kycStatus]}`}
                    ></i>
                  </span>
                </label>
              </div>

              <div className="col-xl-9">
                {kycStatus == 'IN_PROGRESS' ? (
                  <>
                    <button
                      disabled={isKycLoading.startKycLoading}
                      className="btn btn-primary my-1 mx-2 w-150"
                      onClick={startKyc}
                    >
                      Continue KYC
                      {isKycLoading.startKycLoading && (
                        <span className="ml-3 spinner spinner-white"></span>
                      )}
                    </button>

                    <button
                      disabled={isKycLoading.updateKycLoading}
                      className="btn btn-primary my-1 mx-2 w-150"
                      onClick={updateKyc}
                    >
                      Update KYC
                      {isKycLoading.updateKycLoading && (
                        <span className="ml-3 spinner spinner-white"></span>
                      )}
                    </button>
                  </>
                ) : null}

                {kycStatus == 'NOT_STARTED' ? (
                  <>
                    <button
                      disabled={isKycLoading.startKycLoading}
                      className="btn btn-primary my-1 mx-2  w-150"
                      onClick={startKyc}
                    >
                      Start KYC
                      {isKycLoading.startKycLoading && (
                        <span className="ml-3 spinner spinner-white"></span>
                      )}
                    </button>
                    <button
                      disabled={isKycLoading.updateKycLoading}
                      className="btn btn-primary my-1 mx-2  w-150"
                      onClick={updateKyc}
                    >
                      Update KYC
                      {isKycLoading.updateKycLoading && (
                        <span className="ml-3 spinner spinner-white"></span>
                      )}
                    </button>
                  </>
                ) : null}

                {kycStatus == 'COMPLETED' ? (
                  <>
                    <button
                      disabled={isKycLoading.startKycLoading}
                      className="btn btn-primary my-1 mx-2  w-150"
                      onClick={startKyc}
                    >
                      Start KYC
                      {isKycLoading.startKycLoading && (
                        <span className="ml-3 spinner spinner-white"></span>
                      )}
                    </button>
                    <button
                      disabled={isKycLoading.updateKycLoading}
                      className="btn btn-primary my-1 mx-2 w-150"
                      onClick={updateKyc}
                    >
                      Update KYC
                      {isKycLoading.updateKycLoading && (
                        <span className="ml-3 spinner spinner-white"></span>
                      )}
                    </button>
                  </>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default KYC
